export default __webpack_public_path__ + "static/media/particles1.5ee5d179.png";